<ng-container *ngIf="isOfficeFile()">
  <app-file-preview-ms-sdk [fileType]="fileType" [hash]="hash" [isInline]="isInline"
                           [viewMode]="viewMode" [isReadOnly]="isReadOnly"></app-file-preview-ms-sdk>
</ng-container>
<ng-container *ngIf="isGeneralFile()">
  <app-file-preview-general [fileType]="fileType" [hash]="hash" [isInline]="isInline"
                            [viewMode]="viewMode"></app-file-preview-general>
</ng-container>
<ng-container *ngIf="isPdfFile()">
  <app-file-preview-pdf [fileType]="fileType" [hash]="hash" [isInline]="isInline"
                        [viewMode]="viewMode" [isReadOnly]="isReadOnly"></app-file-preview-pdf>
</ng-container>
